import getPkce from 'oauth-pkce';

export const usePkceGen = () => {

    function generatePkceChallenge(callback) {
        getPkce(50, (error, props = { verifier: '', challenge: '' }) => {
            console.log('verifier, challenge - ', props?.verifier, props?.challenge)

            if (callback) {
                return callback(props?.verifier, props?.challenge);
            }
        });
    }

    return { generatePkceChallenge }
}